import { render } from "./NuevaVacuna.vue?vue&type=template&id=b95a8056"
import script from "./NuevaVacuna.vue?vue&type=script&lang=js"
export * from "./NuevaVacuna.vue?vue&type=script&lang=js"

import "./NuevaVacuna.vue?vue&type=style&index=0&id=b95a8056&lang=css"
script.render = render

export default script